<template>
  <a
    v-if="!dismissedStaticFeedback"
    id="sticky-feedback"
    class="p-2"
    :href="href"
    target="_blank"
  >
    <button
      id="sticky-feedback__close"
      class="border-0 p-0 bg-transparent"
      @click="dismiss"
    >
      <svg-close-circle />
    </button>
    <span
      id="sticky-feedback__label"
      class="mt-5 mb-2"
      >{{ i18n.helpUsImprove }}</span
    >
    <span id="sticky-feedback__icon-heart">
      <svg-icon-heart />
    </span>
  </a>
</template>

<script>
  import { mapGetters } from 'vuex'

  const COOKIE_NAME = 'dismiss_sticky_feedback'

  export default {
    components: {
      SvgCloseCircle: () =>
        import(/* webpackChunkName: "chunk-svg-close-circle" */ './svg/close-circle.vue'),
      SvgIconHeart: () =>
        import(/* webpackChunkName: "chunk-svg-icon-heart" */ './svg/icon-heart.vue'),
    },
    props: {
      href: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        i18n: {
          helpUsImprove: gettext('Help us improve'),
        },
        dismissedStaticFeedback: !!this.$cookies.get(COOKIE_NAME) || false,
      }
    },
    computed: {
      ...mapGetters({
        canUseCookies: 'ui/device/canUseCookies',
      }),
    },
    methods: {
      dismiss(event) {
        event.stopPropagation()
        event.preventDefault()
        if (this.canUseCookies) {
          this.$cookies.set(COOKIE_NAME, '1', '12h', '/', locations.cookie_domain)
        }
        this.dismissedStaticFeedback = true
      },
    },
  }
</script>

<style>
  #sticky-feedback {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1040;
    border-radius: var(--button-border-radius) 0 0 var(--button-border-radius);
    background-color: var(--color-blue-950);
    color: var(--color-white);
  }
  #sticky-feedback:hover {
    text-decoration: none;
    opacity: 0.9;
  }
  #sticky-feedback__label {
    font-size: var(--font-size-small-medium);
    writing-mode: sideways-lr;
    text-align: center;
  }
  #sticky-feedback__close,
  #sticky-feedback__icon-heart {
    display: flex;
    justify-content: center;
    color: var(--color-white);
  }
</style>
